const PREPARE_TSV_METHODS = {
    OTP: 'tsv.otp',
    PASSWORD: 'password',
    WGNPS: 'tsv.wgnps',
};
const COMMIT_TSV_METHODS = {
    OTP: 'otp',
    BACKUP: 'backup',
    WGNPS: 'wgnps',
};
const TSV_METHODS_MAP = {
    [PREPARE_TSV_METHODS.OTP]: COMMIT_TSV_METHODS.OTP,
    [PREPARE_TSV_METHODS.WGNPS]: COMMIT_TSV_METHODS.WGNPS,
};

export { COMMIT_TSV_METHODS, PREPARE_TSV_METHODS, TSV_METHODS_MAP };
//# sourceMappingURL=tsvMethods.js.map
